import { render, staticRenderFns } from "./AssignedAlertsList.vue?vue&type=template&id=f0d80e6a&scoped=true&"
import script from "./AssignedAlertsList.vue?vue&type=script&lang=ts&"
export * from "./AssignedAlertsList.vue?vue&type=script&lang=ts&"
import style0 from "./AssignedAlertsList.vue?vue&type=style&index=0&id=f0d80e6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d80e6a",
  null
  
)

export default component.exports